import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ShowUnexpectedError } from '@modules/store/error-store/actions';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppState } from 'src/app/core/app.states';

@Injectable({
    providedIn: 'root',
})
export abstract class RestService {

    constructor(private http: HttpClient, private store$: Store<AppState>) {}

    public getRequest(
        url: string,
        params?: any,
        options?: any
    ): Observable<any> {
        return this.http
            .get<any>(url, { params, ...options })
            .pipe(
                map((res) => res),
                catchError((err) => {
                    this.store$.dispatch(new ShowUnexpectedError(err));
                    return throwError(err);
                })
            );
    }

    public postRequest(
        url: string,
        body?: any,
        params?: any,
        options?: any
    ): Observable<any> {
        return this.http
            .post<any>(url, body, { params, ...options })
            .pipe(
                map((res) => res),
                catchError((err) => {
                    this.store$.dispatch(new ShowUnexpectedError(err));
                    return throwError(err);
                })
            );
    }
}
